/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AccelerationChannelOrientationConfiguration } from './accelerationChannelOrientationConfiguration';
import { ActivityChannelOrientationConfiguration } from './activityChannelOrientationConfiguration';


export interface DeviceTypeEditDto { 
    accelerationChannelOrientations?: AccelerationChannelOrientationConfiguration;
    activityChannelOrientations?: ActivityChannelOrientationConfiguration;
    articleNumbers?: Array<Array<string>>;
    comType: DeviceTypeEditDto.ComTypeEnum;
    configurationOptions?: Array<DeviceTypeEditDto.ConfigurationOptionsEnum>;
    customerName: string;
    isLifetimeCalculationAvailable?: boolean;
    name: string;
}
export namespace DeviceTypeEditDto {
    export const ComTypeEnum = {
        Iridium: 'IRIDIUM',
        Globalstar: 'GLOBALSTAR',
        NbIot: 'NB_IOT',
        NoCommunication: 'NO_COMMUNICATION',
        Gsm: 'GSM'
    } as const;
    export type ComTypeEnum = typeof ComTypeEnum[keyof typeof ComTypeEnum];
    export const ConfigurationOptionsEnum = {
        Usb: 'USB',
        Bluetooth: 'BLUETOOTH',
        Uhf: 'UHF',
        Uart: 'UART'
    } as const;
    export type ConfigurationOptionsEnum = typeof ConfigurationOptionsEnum[keyof typeof ConfigurationOptionsEnum];
}


